import { render, staticRenderFns } from "./CoUserFilter.vue?vue&type=template&id=1f43820f&scoped=true&"
import script from "./CoUserFilter.vue?vue&type=script&lang=ts&"
export * from "./CoUserFilter.vue?vue&type=script&lang=ts&"
import style0 from "./CoUserFilter.vue?vue&type=style&index=0&id=1f43820f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43820f",
  null
  
)

export default component.exports